import { formatImageUrlQuality } from './image.es.js';

const buildSrcset = (src, listWidth) => {
  return listWidth.map((w) => `${formatImageUrlQuality(src, w)} ${w}w`).join(",");
};

export { buildSrcset };
